<template>
  <div>
    <loader v-if="saving" class="mb-1" />
    <div v-else-if="fixed" class="flex flex-wrap mb-1">
      <div v-for="i in max" :key="i" class="w-6">
        <i v-if="value <= i - 1" class="far fa-star text-xl text-yellow-dark mr-1"></i>
        <i v-else-if="value >= i" class="fas fa-star text-xl text-yellow-dark mr-1"></i>
        <i v-else class="fas fa-star-half-alt text-xl text-yellow-dark mr-1"></i>
      </div>
    </div>
    <div v-else-if="active" class="flex flex-wrap mb-1">
      <div v-for="i in max" :key="i" class="relative cursor-pointer w-6" @click="save" @mouseleave="hoverValue = 0">
        <div class="absolute top-0 pin-r w-4 h-6" @mouseenter="hoverValue = i"></div>
        <div class="absolute top-0 pin-l w-3 h-6" @mouseenter="hoverValue = i - 0.5"></div>
        <i v-if="starValue <= i - 1" class="far fa-star text-xl text-yellow-dark mr-1"></i>
        <i v-else-if="starValue === i - 0.5" class="fas fa-star-half-alt text-xl text-yellow-dark mr-1"></i>
        <i v-else-if="starValue >= i" class="fas fa-star text-xl text-yellow-dark mr-1"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../Loader.vue'
export default {
  components: { Loader },
  name: 'StarRating',
  props: {
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: 5,
      type: Number
    },
    step: {
      default: 0.5,
      type: Number
    },
    value: {
      default: 0,
      type: Number
    },
    fixed: {
      default: false,
      type: Boolean
    },
    active: {
      default: false,
      type: Boolean
    },
    saving: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      hoverValue: 0
    }
  },
  computed: {
    totalSteps: function () {
      return parseInt(this.max / this.step)
    },
    starValue: function () {
      return this.hoverValue ? this.hoverValue : this.value
    }
  },
  created () {
  },
  methods: {
    save () {
      this.$emit('save', this.hoverValue)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
 .star {
  width: 20px;
 }
</style>
